module.exports = "/_next/static/files/1186f814739e648f5fce0f09b1bb87ba.jpg";